import type { IconData } from '@stacksjs/iconify-core'

export const dna: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M34.85 13.153C36.308 20.033 38.074 27.925 33 33c-3.911 3.911-9.495 3.759-15 2.816l-4.85-.97c.842 3.966 1.581 7.595.85 10.154l-1 1L2 35l1-1c2.526-.722 6.095-.01 10 .817l.15.03C11.692 27.967 9.926 20.075 15 15c3.911-3.911 9.495-3.76 15-2.816zC34.007 9.187 33.268 5.558 34 3l1-1l11 11l-1 1c-2.526.722-6.095.01-10-.817z\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m19 19l10 10m-3-12l5 5m-14 4l5 5M34 3c-2 7 7 22-1 30c-3.911 3.911-9.495 3.759-15 2.816M3 34c2.526-.722 6.095-.011 10 .816\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M14 45c2-7-7-22 1-30c3.911-3.911 9.496-3.759 15-2.815M45 14c-2.526.722-6.095.011-10-.816M39 8l1 1M8 39l1 1\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default dna
